import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );


import { debounce as _debounce } from 'underscore';
import { indexOf as _indexOf } from 'underscore';




export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {

			$el: undefined,
			main: undefined,

			margin: 280,
			scale: 0.69,
			delay_trail: 0.03,
			time: 0.87,

			arrows: true,
			autoplay: true,
			pauseOnHover: true,
			default_index: 0,
			time_between_slides: 5000

		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);


		this.namespace  = 'slideshow_wide';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;
		this.$container = this.$el.find( '.slides-container' );

		// init!!!!
		if ( this.$el.length > 0 ){
			this.init();
		}

	}

	init(){

		//console.log( 'INIT' );

		// vars
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		this.touch = !$('html').hasClass('no-touch');
		this.slides = [];
		this.slides_array = [];

		this.index = this.options.default_index;
		this.prev_index = -1;
		this.timeout = -1;
		this.running = false;
		this.over = false;

		this.min_slides = 5;

		this.addEvents( true );
		this.initSlider( true );
	}

	initSlider( b ){
		if ( b ){

			let n = this.$container.find( '.slide' ).length;

			if ( n < this.min_slides ){
				this.duplicateSlides( n );
			}

			this.$container.find( '.slide' ).each( (i, el ) => {
				this.slides[i] = $(el);
			} );
			
			if ( this.slides.length >= 5 ){

				this.setSlidesPosition();
				this.onSetSlide()
				this.setCaption( this.index, true );
				

				setTimeout( () => {
				
					this.$el.addClass( 'ready' );
				
				}, 17);
				
			}
		}
	}

	duplicateSlides( n ){
		let slides = [], i, repeat, j;

		repeat = Math.ceil( this.min_slides/n );
		
		for ( j=0; j<repeat; j++ ){
			for( i = 0; i < n; i++ ){
				slides.push(  this.$container.find( '.slide' ).eq(i).clone() );
			}
		}

		this.$container.append( slides );
	}


	setSlidesPosition(){
		// prepare array of 5 elements
		let a = [], i, j, p, $s,
			n = this.slides.length;

		// we only need 5 elements to slides trough ...
		for( i=0; i < this.min_slides; i++){
			j = this.index - 2 + i;
			if ( j < 0 ){
				j = n - 2 + i + this.index;
			}
			if ( j >= n ){
				j -= n;
			}
			a.push( j );
		}

		//console.log( 'index = ' + this.index + ', this.slides.length = ' + n );
		//console.log( a );

		for(i=0; i<n; i++ ){
			$s = this.slides[i];
			if ( _indexOf( a, i ) === -1  ){
				$s.css({visibility:'hidden'})
			}
			else{
				$s.css({visibility:'visible'})
			}
		}		

		this.slides_array = a;

		for(i=0; i<a.length; i++ ){
			$s = this.slides[ a[i] ];
			p = this.getPosition( $s, i );
			gsap.set( $s, { x: p.left, scale: p.scale, y: p.top  });
		}

	}

	getPosition( $s, i ){
		let p 	= {}, 
			//$s 	= this.slides[ this.slides_array[i] ], 
			w 	= this.$win.width(),
			h 	= this.$container.height(), 
			sw 	= $s.width(), 
			sh 	= $s.height();

		p.scale = i === 2 ? 1 : this.options.scale;
		p.top = h/2 - sh/2;

		switch( i ){
			case 0:
				// left left
				p.left 	= - w;
				break;
			case 1:
				// left
				p.left = - sw + this.options.margin;
				break;
			case 2:
				// index
				p.left = w/2 - sw/2;
				break;
			case 3:
				// right
				p.left = w - this.options.margin;
				break;
			case 4:
				// right right
				p.left 	= 2*w;
				break;
		}
		return p
	}

	onResize(){
		if ( ! this.running ) {
			this.setSlidesPosition();
		} 
	}

    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 37 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }


	setSlide( j, next ){
		let $s, tl, p, i;

		this.setCaption( this.prev_index, false );

		this.running = true;
		tl = gsap.timeline({ onComplete: ()=>{ this.onSetSlide() } });

		if ( next ){
			for( i=1; i<this.slides_array.length; i++ ){
				$s = this.slides[ this.slides_array[i] ];
				p = this.getPosition( $s, i - 1 );
				if ( i===1 ){
					tl.add( ()=>{
						this.setCaption( this.index, true );
					})
				}		
				tl.to( $s, {x: p.left, scale: p.scale, y:p.top, ease:'power2.out',duration:this.options.time}, "-=" + (i>1?this.options.time-this.options.delay_trail:0) );
			}
		}
		else{
			for( i=0; i<this.slides_array.length-1; i++ ){
				$s = this.slides[ this.slides_array[i] ];
				p = this.getPosition( $s, i + 1 );
				if ( i===0 ){
					tl.add( ()=>{
						this.setCaption( this.index, true );
					})
				}		
				tl.to( $s, {x: p.left, scale: p.scale, y:p.top, ease:'power2.out',duration:this.options.time}, "-=" + (i>0?this.options.time-this.options.delay_trail:0) );				
			}
		}

	}

	onSetSlide(){
		this.setSlidesPosition()
		this.running = false;
		this.setAutoPlay();
		//this.setCaption( this.index, true );
	}

	setCaption( i, b){
		let $s = this.slides[ i ];
		gsap.fromTo( $s.find( '.caption .inner' ), { opacity:b?0:1  }, { opacity: b?1:0, duration: b?0.8 :0.2, ease:'linear', delay: b ? 0.2 : 0 });
	}

	setAutoPlay(){
		if ( this.options.pauseOnHover ){
			if ( this.over ){
				return;
			}
		}
		if ( this.options.autoplay && this.isInView() ){
			clearTimeout( this.timeout );
			this.timeout = setTimeout( () => {
				this.setNextSlide();
			}, this.options.time_between_slides );
		}
	}

	isInView(){
		return this.$el.hasClass( 'in-view' );
	}
	initCheckInView(b){
		if ( b ){
			this.id_scroll_trigger = this.namespace + '-' + Math.random();

			ScrollTrigger.create({
				trigger: this.$el,
				start: "top bottom", // the default values
				end: "bottom top",
				scroller: $(this.options.main.options.$scroll_el),
				scrub: true,
				markers: false,
				id:this.id_scroll_trigger,
				toggleClass: 'in-view',
				//once: true
				onToggle: ( self )=>{
					//console.log( self );
					if ( self.isActive ){
						this.setAutoPlay()
					}
				}
			});

		}
		else{
			ScrollTrigger.getById( this.id_scroll_trigger ).kill();
		}
	}

	setNextSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index += 1;
		if ( this.index >= this.slides.length ){
			this.index = 0;
		}
		this.setSlide( this.index, true );
	}

	setPrevSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index -= 1;
		if ( this.index < 0 ){
			this.index = this.slides.length - 1;
		}
		this.setSlide( this.index, false );
	}

	addEvents( b ){
		if ( b ){
			this.$el.on( 'mouseenter', () => {
				this.over = true;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					clearTimeout( this.timeout );
				}
			});
			this.$el.on( 'mouseleave', () => {
				this.over = false;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					if ( this.running ){
						//this.setAutoPlay();
					}
					else{
						//this.setNextSlide();
						this.setAutoPlay();
					}
				}
			});
			if( this.options.arrows ){
				this.$el.find( '.arrow' ).on( 'click', (e) => {
					if ( $(e.currentTarget).hasClass( 'left' ) ){
						this.setPrevSlide();
					}
					else{
						this.setNextSlide();
					}
				});
			}
		}
		else{
			this.$el.off( 'mouseenter' );
			this.$el.off( 'mouseleave' );
			if( this.options.arrows ){
					this.$el.find( '.arrow' ).off( 'click' );
			}
		}
		this.debounceResize(b);
		this.initCheckInView(b);
	}

	// public methods //////////////////////////////////////////////////////////////////////////
	destroy(){
		this.initSlider( false );
		this.addEvents( false );
	}

}



